import React from "react";
import {
  Switch,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Typography,
  Stack
} from "@mui/material";
import { useTheme } from "@mui/system";

const AutobiaSwitch = ({
  checked,
  onChange,
  label,
  disabled = false,
  error = false,
  helperText,
  color = "primary",
  size = "medium",
  labelPlacement = "end",
}) => {
  const theme = useTheme();

  const switchComponent = (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      color={color}
      size={size}
      sx={{
        "& .MuiSwitch-switchBase.Mui-checked": {
          color: color === "secondary" 
            ? theme.palette.secondary.main 
            : theme.palette.primary.main,
          "&:hover": {
            backgroundColor: color === "secondary" 
              ? `${theme.palette.secondary.main}08` 
              : `${theme.palette.primary.main}08`,
          },
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
          backgroundColor: color === "secondary" 
            ? theme.palette.secondary.main 
            : theme.palette.primary.main,
        },
        "& .MuiSwitch-track": {
          backgroundColor: theme.palette.gray.g300,
        },
      }}
    />
  );

  const labelComponent = label && (
    <Typography
      variant="body2"
      color={disabled ? "gray.g400" : "gray.g700"}
      sx={{
        userSelect: "none",
        fontSize: size === "small" ? "0.8rem" : "0.875rem",
        fontWeight: 500,
      }}
    >
      {label}
    </Typography>
  );

  return (
    <FormControl error={error} disabled={disabled}>
      <Stack direction="row" alignItems="center" spacing={1}>
        {labelPlacement === "start" && labelComponent}
        {switchComponent}
        {labelPlacement === "end" && labelComponent}
      </Stack>
      {helperText && (
        <FormHelperText sx={{ mt: 0.5 }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default AutobiaSwitch;